@for (followUp of followupHistory(); track $index) {

<div class="card rounded-3 border-2 mb-3">
    <div class="card-header border-0 bg-white rounded-3">
        <span class="fw-bold" [class.text-secondary]="!$last || followUpLoading">
            {{ followUp.question }}
        </span>
    </div>
    <div class="d-flex flex-row p-3">
        <div>
            <!-- Avatar immagine -->
            <img src="images/Favicon-Tim-48x48.ico" alt="Tim Logo" style="width:32px; height:32px;">
        </div>
        <div class="ps-2 flex-grow-1 text-secondary followup">
            @if (followUp.textWithCitations) {
                <div [innerHTML]="followUp.textWithCitations | safeHtml" class="fade-in"></div>
            } @else {
                <span [innerHTML]="followUp.answer | markdown | async | safeHtml" class="fade-in"></span>
            }
        </div>
    </div>
</div>
}